export enum PermissionOperator {
  OR = 0,
  AND = 1,
}
